import { usePreferences } from "@hooks";
import { localesOptions } from "@temp/components/Locale";
import React from "react";
import * as S from "./styles";
export function LocalePicker(_ref) {
  var onPicked = _ref.onPicked;

  var _usePreferences = usePreferences(),
      preferences = _usePreferences.preferences,
      setPreferences = _usePreferences.setPreferences;

  var handlePreferenceChange = function handlePreferenceChange(data) {
    setPreferences(data);
    onPicked();
  };

  return React.createElement(S.Wrapper, null, localesOptions.map(function (item) {
    return React.createElement(S.Item, {
      key: item.localeName,
      onClick: function onClick() {
        return handlePreferenceChange({
          locale: item.localeCode
        });
      }
    }, React.createElement("img", {
      src: item.localeIcons,
      alt: ""
    }), React.createElement(S.ItemLabel, {
      active: preferences.locale === item.localeCode
    }, React.createElement("span", null, item.localeName)));
  }));
}